var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Watch, Component } from 'vue-property-decorator';
import AccoutCheckService from '../../../api/AccoutCheckService';
import CommonService from "../../../api/CommonService";
var LeftTree = (function (_super) {
    __extends(LeftTree, _super);
    function LeftTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterText = "";
        _this.defaultProps = {
            label: 'business_name',
            id: "supplier_to_business_id"
        };
        _this.data = [];
        _this.height = document.documentElement.clientHeight - 240;
        _this.settlementList = [];
        _this.accountdatetype = '-1';
        return _this;
    }
    LeftTree.prototype.watchFilter = function (val) {
        this.$refs.tree.filter(val);
    };
    LeftTree.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    LeftTree.prototype.nodeClick = function (data, node, target) {
        if (data.children) {
            return;
        }
        data.account_val_times = 0;
        this.$emit('node-click', data);
    };
    LeftTree.prototype.mounted = function () {
        this.getSettlementList();
        this.getGroupchilds();
    };
    LeftTree.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
        this.commonservice = CommonService.getInstance();
    };
    LeftTree.prototype.getGroupchilds = function () {
        var _this = this;
        this.service.getGroupchilds({
            accountdatetype: this.accountdatetype,
            customer_sort: 1
        }).then(function (res) {
            res.data.data.forEach(function (item, index) {
                item.supplier_to_business_id = "group" + index;
                item.business_name = item.group_name;
            });
            _this.data = res.data.data;
            if (_this.data.length) {
                _this.$nextTick(function () {
                    _this.$refs.tree.setCurrentKey(_this.data[0].children[0].supplier_to_business_id);
                    _this.$emit('node-click', _this.$refs.tree.getCurrentNode());
                });
            }
        });
    };
    LeftTree.prototype.getSettlementList = function () {
        var _this = this;
        this.commonservice.getSettlementList().then(function (res) {
            var Data = Array.isArray(res.data.data) ? res.data.data : [];
            Data.unshift({
                value: '-1',
                name: '全部结算方式'
            });
            _this.settlementList = Data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    LeftTree.prototype.updateSettlement = function () {
        console.log(this.accountdatetype, 333);
        this.getGroupchilds();
    };
    __decorate([
        Watch("filterText")
    ], LeftTree.prototype, "watchFilter", null);
    LeftTree = __decorate([
        Component
    ], LeftTree);
    return LeftTree;
}(Vue));
export default LeftTree;
